<template>
  <div class="invite-friend card">
    <h1 class="invite-friend__title page-title">Invite a friend to the Tavern</h1>
    <p class="invite-friend__description">
      Your friend will receive a personal link by which he can register in the
      Tavern
    </p>

    <el-form
      :model="formData"
      :rules="formRules"
      @submit.native.prevent="validateForm"
      ref="inviteForm"
      label-position="top"
    >
      <el-form-item label="Email" prop="email" :error="formErrors.email">
        <el-input v-model="formData.email" />
      </el-form-item>

      <div class="invite-friend__buttons">
        <el-button
          type="primary"
          @click="validateForm"
          :disabled="isButtonDisabled('invite-friend')"
        >
          Invite
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { sendInviteToTavern } from '@/api/user.js';
import { parseErrorsByFields } from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'InviteFriend',
  mixins: [disableButton],
  data() {
    return {
      formData: {
        email: null,
      },
      formErrors: {
        email: null,
      },
      formRules: {
        email: [
          {
            required: true,
            trigger: 'input',
            message: 'Please enter email',
          },
        ],
      },
    };
  },
  methods: {
    parseErrorsByFields,
    showMessage,
    async requestSendInvite() {
      this.disableButton('invite-friend');
      const { email } = this.formData;
      const { success, errors } = await sendInviteToTavern({ email });
      this.enableButton('invite-friend');

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Invitation has been sent',
        });
      } else if (errors) {
        this.formErrors = {
          ...this.formErrors,
          ...this.parseErrorsByFields(errors),
        };
      }
    },
    validateForm() {
      const { email } = this.formData;

      if (this.$refs.inviteForm) {
        this.$refs.inviteForm.validate();
      }

      if (email && email.trim()) {
        this.requestSendInvite();
      }
    },
    clearForm() {
      this.formData.email = null;
    },
    clearErrors() {
      this.formErrors.email = null;
    },
  },
};
</script>

<style lang="scss">
.invite-friend {
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-65);
    font-weight: normal;
    font-size: var(--font-size-600);
  }
  &__description {
  }
  &__buttons {
    text-align: right;
  }
}
</style>
